import { makeDoFetchJiraIssueSearch } from 'ducks/integrations/jiraShared'

export default makeDoFetchJiraIssueSearch(
  'integrations/jira_server',
  () => 'proxy/jira-server/rest/api/2/search/jql'
)
